import { useState } from 'react';
import { saveAssetEntry, deleteAssetEntry as delEntry } from '../../api';
import LocationPickerModal from '../LocationPickerModal';

const EMPTY = { buildingArea: '', floor: '0', locationName: '', locationPath: '', sinkCount: '', whbCount: '', wcCount: '', urinalCount: '', tmvCount: '', pouHeaterRef: '', waterHeaterType: '', showerType: '', otherNotes: '', isScaledOutlet: false, mainsWaterTemp: '', coldWaterTemp: '', hotWaterTemp: '', mixedWaterTemp: '', isSentinel: false, isLittleUsed: false };

export default function AssetRegisterTab({ report, onSave, readOnly = false }) {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [msg, setMsg] = useState('');
  const [pickerOpen, setPickerOpen] = useState(false);

  const handleChange = (e) => {
    const val = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm({ ...form, [e.target.name]: val });
  };

  const startNew = () => { setEditing('new'); setForm(EMPTY); };
  const startEdit = (item) => { setEditing(item.id); setForm({ ...item }); };
  const cancel = () => { setEditing(null); setForm(EMPTY); };

  const handleSave = async () => {
    try {
      await saveAssetEntry(report.id, {
        ...form,
        id: editing === 'new' ? null : editing,
        sinkCount: form.sinkCount ? Number(form.sinkCount) : null,
        whbCount: form.whbCount ? Number(form.whbCount) : null,
        wcCount: form.wcCount ? Number(form.wcCount) : null,
        urinalCount: form.urinalCount ? Number(form.urinalCount) : null,
        tmvCount: form.tmvCount ? Number(form.tmvCount) : null,
        sortOrder: (report.assetRegister || []).length,
      });
      setEditing(null);
      setForm(EMPTY);
      setMsg('Saved');
      onSave();
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
  };

  const handleDelete = async (id) => { if (!window.confirm('Delete this asset entry?')) return; await delEntry(id); onSave(); };

  const entries = report.assetRegister || [];

  return (
    <div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {!readOnly && <button className="btn btn-primary" onClick={startNew} style={{ marginBottom: '1rem' }}>Add Outlet</button>}

      {!readOnly && editing && (
        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: '1rem', marginBottom: '1rem', background: '#fafafa' }}>
          <div className="form-group">
            <label>Location</label>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              {form.locationPath || form.locationName ? (
                <span style={{ flex: 1, padding: '0.5rem', background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 4, fontSize: '0.85rem' }}>
                  {form.locationPath || form.locationName}
                  {form.floor && form.floor !== '0' && <span style={{ color: '#6b7280', marginLeft: 8 }}>(Floor {form.floor})</span>}
                </span>
              ) : (
                <span style={{ flex: 1, padding: '0.5rem', color: '#9ca3af', fontSize: '0.85rem' }}>No location selected</span>
              )}
              <button type="button" className="btn btn-outline" style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem', whiteSpace: 'nowrap', color: '#333', borderColor: '#ccc' }} onClick={() => setPickerOpen(true)}>
                {form.locationPath || form.locationName ? 'Change' : 'Pick Location'}
              </button>
            </div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Sinks</label><input type="number" name="sinkCount" value={form.sinkCount || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>WHB <small style={{fontWeight:'normal',color:'#888'}}>(Wash Hand Basin)</small></label><input type="number" name="whbCount" value={form.whbCount || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>WC</label><input type="number" name="wcCount" value={form.wcCount || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>Urinals</label><input type="number" name="urinalCount" value={form.urinalCount || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>TMV <small style={{fontWeight:'normal',color:'#888'}}>(Thermostatic Mixing Valve)</small></label><input type="number" name="tmvCount" value={form.tmvCount || ''} onChange={handleChange} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>POU Heater Ref</label><input name="pouHeaterRef" value={form.pouHeaterRef || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>Water Heater Type</label><input name="waterHeaterType" value={form.waterHeaterType || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>Shower Type</label><input name="showerType" value={form.showerType || ''} onChange={handleChange} /></div>
          </div>
          <div className="form-group"><label>Other Notes</label><input name="otherNotes" value={form.otherNotes || ''} onChange={handleChange} placeholder="Dead-leg, SENTINEL, Flexible Hose, etc." /></div>
          <div className="form-row">
            <div className="form-group"><label>Mains Temp</label><input name="mainsWaterTemp" value={form.mainsWaterTemp || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>Cold Temp</label><input name="coldWaterTemp" value={form.coldWaterTemp || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>Hot Temp</label><input name="hotWaterTemp" value={form.hotWaterTemp || ''} onChange={handleChange} /></div>
            <div className="form-group"><label>Mixed Temp</label><input name="mixedWaterTemp" value={form.mixedWaterTemp || ''} onChange={handleChange} /></div>
          </div>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '0.5rem' }}>
            <label><input type="checkbox" name="isSentinel" checked={form.isSentinel || false} onChange={handleChange} /> Sentinel</label>
            <label><input type="checkbox" name="isScaledOutlet" checked={form.isScaledOutlet || false} onChange={handleChange} /> Scaled Outlet</label>
            <label><input type="checkbox" name="isLittleUsed" checked={form.isLittleUsed || false} onChange={handleChange} /> Little Used</label>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className="btn btn-primary" onClick={handleSave}>Save</button>
            <button className="btn btn-outline" style={{ color: '#333', borderColor: '#ccc' }} onClick={cancel}>Cancel</button>
          </div>
        </div>
      )}

      <div className="table-scroll">
        <table className="data-table" style={{ fontSize: '0.75rem' }}>
          <thead><tr><th>Location</th><th>Sink</th><th>WHB</th><th>WC</th><th>POU</th><th>Shower</th><th>Other</th><th>Mains</th><th>Cold</th><th>Hot</th><th>Mixed</th>{!readOnly && <th></th>}</tr></thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td>{e.locationPath || [e.buildingArea, e.locationName].filter(Boolean).join(' > ')}</td>
                <td>{e.sinkCount || ''}</td>
                <td>{e.whbCount || ''}</td>
                <td>{e.wcCount || ''}</td>
                <td>{e.pouHeaterRef || ''}</td>
                <td>{e.showerType || ''}</td>
                <td>{e.otherNotes || ''}</td>
                <td>{e.mainsWaterTemp || ''}</td>
                <td>{e.coldWaterTemp || ''}</td>
                <td>{e.hotWaterTemp || ''}</td>
                <td>{e.mixedWaterTemp || ''}</td>
                {!readOnly && <td style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
                  <button onClick={() => startEdit(e)} style={{ cursor: 'pointer', border: '1px solid #d0d5dd', background: '#fff', color: '#4361ee', fontSize: '0.8rem', padding: '5px 12px', borderRadius: 4, marginRight: 8 }}>&#9998; Edit</button>
                  <button onClick={() => handleDelete(e.id)} style={{ cursor: 'pointer', border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', fontSize: '0.8rem', padding: '5px 12px', borderRadius: 4 }}>&times; Delete</button>
                </td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {entries.length === 0 && <p style={{ color: '#888' }}>No asset register entries yet.</p>}

      <LocationPickerModal
        isOpen={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onSelect={(loc) => {
          const parts = (loc.path || loc.name).split(' > ');
          setForm((f) => ({
            ...f,
            locationName: loc.name,
            locationPath: loc.path || loc.name,
            buildingArea: parts[0] || '',
            floor: loc.floorNumber != null ? String(loc.floorNumber) : f.floor,
          }));
        }}
        siteId={report.siteId}
        organisationId={report.organisationId}
        title="Pick Location"
      />
    </div>
  );
}
